import { QueryKey, useQuery, UseQueryOptions } from 'react-query';

import { getReactionsObject, ReactionsResponse } from 'services/reactions';

export default function useShareBar(
  slug?: string,
  type?: string,
  options?: Omit<UseQueryOptions<ReactionsResponse, Error, ReactionsResponse, QueryKey>, 'queryKey'>
) {
  return useQuery<ReactionsResponse, Error>(
    [`reactions`, slug, type],
    () =>
      getReactionsObject(slug, type).then((response) => {
        if (!response.ok) {
          throw new Error(response.originalError?.message);
        }

        return response.data;
      }),
    {
      ...options,
      cacheTime: 600000,
      retry: false,
      staleTime: 0,
    }
  );
}
